import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useOwasEvaluationContext } from '../context';
import * as S from './styles';

export enum TASKS_FILTER {
	ALL = 'all',
	NOT_ANALYZED = 'not_analyzed'
}

export function Analyzed(): JSX.Element {
	const { filters, onFilterAnalyzed } = useOwasEvaluationContext();

	function handleOnClick(type: string): void {
		onFilterAnalyzed(type);
	}

	return (
		<Row align="middle" gutter={[{ lg: 10, xxl: 15 }, 0]} style={{ width: '100%' }}>
			<Col span={10}>
				<S.ButtonWrapper
					$selected={filters.type === TASKS_FILTER.ALL}
					onClick={() => handleOnClick(TASKS_FILTER.ALL)}
				>
					{I18n.get('All tasks')}
				</S.ButtonWrapper>
			</Col>
			<Col span={14}>
				<S.ButtonWrapper
					$selected={filters.type === TASKS_FILTER.NOT_ANALYZED}
					onClick={() => handleOnClick(TASKS_FILTER.NOT_ANALYZED)}
				>
					{I18n.get('Tasks not analyzed')}
				</S.ButtonWrapper>
			</Col>
		</Row>
	);
}
